import React from "react";
import { Button, Grid, Typography } from "@mui/material";
import { Field, Form, Formik, FormikProps } from "formik";
import { TextField } from "formik-mui";
import { useTranslation } from "react-i18next";

import { ButtonGrid } from "src/components/form-components/ButtonGrid";
import { ButtonLoading } from "src/components/ButtonLoading";
import { ScenarioMutationData } from "src/hooks/scenarios";
import { ServerErrors } from "src/components/form-components/ServerErrors";
import { APIError } from "src/types";
import { useScenarioSchema } from "src/schemas/scenario.schema";

export type ScenarioFormData = ScenarioMutationData;

interface Props {
  title: string;
  readOnly?: boolean;
  data: ScenarioFormData;
  onClose: () => void;
  onSubmit: (values: ScenarioFormData) => void;
  isLoading: boolean;
  errors?: APIError[] | null;
  formRef?: React.MutableRefObject<FormikProps<ScenarioFormData> | null>;
}

export function ScenarioForm(props: Props) {
  const { t } = useTranslation();
  const validationSchema = useScenarioSchema();

  const initialValues: ScenarioFormData = {
    name: props.data.name,
  };

  return render();

  function render() {
    return (
      <Formik
        innerRef={props.formRef}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (values: ScenarioFormData) => {
          return props.onSubmit(values);
        }}
        enableReinitialize
      >
        {({ isSubmitting }) => (
          <Form>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography>{props.title}</Typography>
              </Grid>

              <Grid item xs={12}>
                <Field
                  component={TextField}
                  name="name"
                  label={t("label.name")}
                  type="text"
                  variant="outlined"
                  fullWidth
                  disabled={props.readOnly}
                />
              </Grid>

              {props.errors && (
                <Grid item xs={12}>
                  <ServerErrors data={props.errors} />
                </Grid>
              )}

              {!props.readOnly && (
                <ButtonGrid container item xs={12} sx={{ justifyContent: "flex-end" }}>
                  <Button variant="text" onClick={props.onClose}>
                    {t("label.cancel")}
                  </Button>
                  <ButtonLoading
                    isLoading={isSubmitting || props.isLoading}
                    type="submit"
                    color="primary"
                    variant="contained"
                  >
                    {t("label.save")}
                  </ButtonLoading>
                </ButtonGrid>
              )}
            </Grid>
          </Form>
        )}
      </Formik>
    );
  }
}
